import { RG_TYPE as c, RG_TECH_CLASS as a } from "@project-rouge/rg-core";
const t = (e) => e.type !== c.TechnicalSpace ? !1 : e.data.instance.spaceClass === a.Service;
export {
  t as isServiceTechSpace
};
//# sourceMappingURL=index7.js.map
